import { graphql } from "@opensea/graphql"
import { AddToCalendarOptionsFragment } from "./AddToCalendarOptions.fragment"

export const SetDropReminderModalFragment = graphql(
  `
    fragment SetDropReminderModal on Drop {
      stages {
        uuid
        startTime
        label
        stageIndex
      }
      ...AddToCalendarOptions
    }
  `,
  [AddToCalendarOptionsFragment],
)
